import baseAPI from '@/http'

const routerExcel = 'api/arquivo/excel'

export const relatoriosApi = {
    oportunidade: (municipioId) => baseAPI.get(`${routerExcel}/download-oportunidades/${municipioId}`, {
        responseType: 'blob'
    }),
    agenteTerritorial: (municipioId) => baseAPI.get(`${routerExcel}/download-agente-territorial/${municipioId}`, {
        responseType: 'blob'
    }),
}
